exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.module-scratch #canvas[data-v-26a3355e] {\n  position: relative;\n  width: 270px;\n  height: 162px;\n  margin: 0 auto;\n}\n.module-scratch #canvas .cont[data-v-26a3355e] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 270px;\n  height: 162px;\n  color: #8e5543;\n  font-weight: bold;\n  background-color: #fede90;\n  text-align: center;\n  line-height: 162px;\n  font-size: 34px;\n}\n.module-scratch #canvas canvas[data-v-26a3355e] {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n", ""]);

// exports
